import React, { useContext } from 'react';
import { bool, string } from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { withLayoutGroup } from '@thd-olt-component-react/layout-manager';
import { withHydrator, declareContexts } from '@thd-olt-component-react/hydrator';
import { withDynamicComponent } from '@thd-nucleus/app-render';
import { QueryContext } from '@thd-nucleus/data-sources';
import { dynamicRecsDataModel } from '../dataModel';
import { LoadingPlaceholder } from '../core/LoadingPlaceholder';
import DynamicRecs from './DynamicRecs';

const DynamicRecsWrapperComponent = (props) => {
  const { anchor, anchorId } = props;
  const { isServer } = useContext(ExperienceContext);

  if (!isServer) {
    return (
    /* eslint-disable react/jsx-props-no-spreading */
    /* webpackPrefetch: true, webpackChunkName: "DynamicRecs" */
      <DynamicRecs {...props} anchor={anchor || anchorId} />
    );
  }

  return null;
};

DynamicRecsWrapperComponent.displayName = 'DynamicRecsWrapper';

const propTypes = {
  anchorId: string.isRequired,
  schemaName: string.isRequired,
  anchor: string
};
const defaultProps = {
  anchor: null
};
const dataModel = dynamicRecsDataModel;

DynamicRecsWrapperComponent.propTypes = propTypes;
DynamicRecsWrapperComponent.defaultProps = defaultProps;
DynamicRecsWrapperComponent.dataModel = dataModel;

const HydratedDynamicRecs = withHydrator({
  delay: 1500,
  placeholder: (<LoadingPlaceholder />),
  preserveCtxVal: 'clientStore',
  contexts: declareContexts([QueryContext])
}, DynamicRecsWrapperComponent);

export const DynamicRecsWrapper = withLayoutGroup({
  name: 'DynamicRecsWrapper'
}, withDynamicComponent(HydratedDynamicRecs));

DynamicRecsWrapper.propTypes = propTypes;
DynamicRecsWrapper.defaultProps = defaultProps;
DynamicRecsWrapper.dataModel = dataModel;
